import { Component, Input, Output, EventEmitter, ChangeDetectionStrategy } from '@angular/core';
import { NgIf } from '@angular/common';
import * as model from "../../models";
import * as ui from "../../models/ui";
import { DataTableObject, DataTableRow } from "../data-table"


@Component({
	selector: 'data-table',
	templateUrl: "./data-table.html",
	changeDetection: ChangeDetectionStrategy.OnPush,
	styles: [require("./data-table.scss")]
})

export class DataTable {
	@Input() private data: DataTableObject
	@Input() private tableCssClass: string
}



// WEBPACK FOOTER //
// ./src/app/ui-helper/data-table/data-table.component.ts